import { Checkbox, FormControlLabel, ListItemText, MenuItem, TextField } from "@mui/material";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import ColouredDot from "./ColouredDot";
import React from "react";

export const renderTextField =
  (name: string, label: string, type: string = "text", inputProps: {} = {},
   disabled: boolean = false) => (field: any, error: any) =>
  (
    <TextField
      type={type}
      fullWidth
      name={name}
      label={label}
      value={field.value}
      onChange={field.onChange}
      error={error !== undefined}
      helperText={error ? error.message : ""}
      InputProps={inputProps}
      disabled={disabled}
    ></TextField>
  );
export const renderCheckBoxField =
  (name: string, label: string) =>
    (field: any) =>
    (
      <FormControlLabel
        label={label}
        sx={{ mt: 2 }}
        control={
          <Checkbox
            color={"accent"}
            value={field.value}
            onChange={field.onChange}
            checked={field.value}
          />
        }
      />
    );

export const renderDatePickerFrom = (name: string, label: string, useClock: boolean = false, disabled?: boolean) =>
  (field: any, error: any, state: any, values: any) => {
    const Component = useClock ? DateTimePicker : DatePicker;
    const inputFormat = useClock ? "DD/MM/YYYY HH:mm" : "L";

    return (
      <Component
        label={label}
        value={field.value}
        maxDate={values[name + "To"] !== null ? values[name + "To"] : null}
        onChange={field.onChange}
        ampm={false}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            id={name + "From"}
            disabled={disabled}
            error={error !== undefined}
            helperText={error ? error.message : ""}
          />
        )}
        inputFormat={inputFormat}
      />
    );
  };


export const rendereDatePickerTo =
  (name: string, label: string, useClock: boolean = false, disabled?: boolean) =>
    (field: any, error: any, state: any, values: any) => {
      const Component = useClock ? DateTimePicker : DatePicker;
      const inputFormat = useClock ? "DD/MM/YYYY HH:mm" : "L";

      return (
        <Component
          label={label}
          value={field.value}
          minDate={values[name + "From"] !== null ? values[name + "From"] : null}
          onChange={field.onChange}
          ampm={false}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              id={name + "To"}
              disabled={disabled}
              error={error !== undefined}
              helperText={error ? error.message : ""}
            />
          )}
          inputFormat={inputFormat}
        />
      );
    };

export const renderSelect =
  (name: string, label: string, items: any[], disabled?:boolean) => (field: any) =>
  (
    <TextField
      name={name}
      fullWidth
      select
      label={label}
      value={field.value}
      onChange={field.onChange}
      disabled={disabled}
    >
      <MenuItem value={""}>
        <em />
      </MenuItem>
      {items.map((option: any) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );

export const renderMultiSelect =
  (name: string, label: string, items: any[]) => (field: any) =>
  (
    <TextField
      name={name}
      fullWidth
      select
      SelectProps={{
        multiple: true,
        renderValue: (selected: any) =>
          selected
            .map((s: any) => items.find((ss) => ss.value === s)!.label)
            .join(", "),
      }}
      label={label}
      value={field.value}
      onChange={field.onChange}
    >
      {items.map((status) => (
        <MenuItem key={status.value} value={status.value}>
          <Checkbox checked={field.value.indexOf(status.value) > -1} />
          <ColouredDot color={status?.color} />
          <ListItemText primary={status.label} />
        </MenuItem>
      ))}
    </TextField>
  );


export const renderMultiSelectCountries =
  (name: string, label: string,items: any[]) => (field :any, error:any, formState:any, watchAll:any, setValue:any) => (
      <TextField
          fullWidth
          label={label}
          name={name}
          select
          SelectProps={{
              multiple: true,
              renderValue: (selected: any) =>
                  selected
                      .join(', ')
          }}
          value={field.value || []}
          onChange={(e) => {
              const value = e.target.value;
              if (value[value.length - 1] === "all") {
                   setValue(name, (items &&  field.value)  && field.value.length === items.length ? [] : items)
              } else {
                  field.onChange(e)
              }
          }}
      >
          <MenuItem value="all">
              <Checkbox
                  color={"accent"}
                  checked={  (items &&  field.value) && items.length > 0 && field.value.length  === items.length}
                  indeterminate={ (items &&  field.value) &&
                      field.value.length > 0 && field.value.length < items.length
                  }
              />
              <ListItemText primary={"All"} />
          </MenuItem>
          {items.map((country) => (
              <MenuItem key={country} value={country}>
                  <Checkbox
                      color="accent"
                      checked={(field.value || []).includes(country)}
                  />
                  <ListItemText primary={country} />
              </MenuItem>
          ))}
      </TextField>
  );
